<div class="item-wrapper">
  <!-- TODO: separate row when collapsed that is clickable, will fix the cursor issues -->
  <div
    class="cost-item"
    tabindex="0"
    role="button"
    enterPress="expandItem()"
    (keydown.enter)="expandItem()"
    (click)="expandItem()"
  >
    <div class="label-row" *ngIf="isExpanded">
      <div class="label title">
        {{ 'productionCost.costAccordionItem.positionTitle' | translate }}
      </div>
      <div class="label name">
        {{ 'productionCost.costAccordionItem.vendorName' | translate }}
      </div>
      <div class="label description">
        {{ 'productionCost.costAccordionItem.description' | translate }}
      </div>
      <div class="label bill-date">
        {{ 'productionCost.costAccordionItem.dateOfBill' | translate }}
      </div>
      <div class="label date">
        {{ 'productionCost.costAccordionItem.paymentDate' | translate }}
      </div>
      <div class="label unit">
        {{ 'productionCost.costAccordionItem.unit' | translate }}
      </div>
      <div class="label days">
        {{ 'productionCost.costAccordionItem.days' | translate }}
      </div>
      <div class="label cost">
        {{ 'productionCost.costAccordionItem.cost' | translate }}
      </div>
      <div class="label actual">
        {{ 'productionCost.costAccordionItem.costInclTax' | translate }}
      </div>
      <div class="label estimated">
        {{ 'productionCost.costAccordionItem.estimatedCost' | translate }}
      </div>
    </div>
    <div class="main-row">
      <div class="checkbox" (click)="onToggleSelection($event)">
        <img src="assets/check-box.svg" *ngIf="multiselected" />
      </div>

      <div
        id="{{ 'title' + item._id }}"
        class="title clickable"
        [class.field]="isExpanded"
        tabindex="0"
        role="button"
        [class.is-disabled]="isReadOnly"
        enterPress="openModal('dropdown-title' + item._id, $event)"
        (keydown.enter)="openModal('dropdown-title' + item._id, $event)"
        (click)="openModal('dropdown-title' + item._id, $event)"
      >
        <!-- <div
          class="label"
          *ngIf="(!positionEdit || positionEdit.length < 1) && !item.position"
        >
          Title
        </div> -->

        <div class="value" *ngIf="!isExpanded">
          {{ (positionEdit | translate) ?? (item.position | translate) }}
        </div>
        <input
          *ngIf="isExpanded"
          focusSelect
          [disabled]="isReadOnly"
          value="{{ searchPosition | translate }}"
          (input)="onTypeSearchPosition($event)"
          style="width: 140px"
        />
        <img
          src="assets/arrow-down-purple.svg"
          class="arrow"
          *ngIf="isExpanded"
        />
        <ops-dropdown
          id="{{ 'dropdown-title' + item._id }}"
          parentId="{{ 'title' + item._id }}"
          [options]="positionOptions"
          [isMultiSelect]="false"
          [startingFocusIndex]="0"
          [indent]="10"
          [optionSpacing]="10"
          (valueSelected)="onSelectPosition($event)"
          class="dropdown-component"
        >
        </ops-dropdown>
      </div>
      <div class="name" [class.is-disabled]="isReadOnly">
        <!-- TODO: conditionally show the item value instead of edit value -->
        <div *ngIf="!isExpanded">
          {{ (nameEdit | translate) ?? (item.name | translate) }}
        </div>
        <input
          tabindex="0"
          class="field"
          *ngIf="isExpanded"
          [disabled]="isReadOnly"
          value="{{ nameEdit | translate }}"
          (keyup)="onEditName($event)"
          (click)="stopPropagation($event)"
          focusSelect
        />
      </div>
      <div class="description" [class.is-disabled]="isReadOnly">
        <!-- TODO: conditionally show the item value instead of edit value -->
        <div *ngIf="!isExpanded">{{ descriptionEdit ?? item.description }}</div>
        <input
          tabindex="0"
          class="field"
          *ngIf="isExpanded"
          [disabled]="isReadOnly"
          value="{{ descriptionEdit }}"
          (keyup)="onEditDescription($event)"
          (click)="stopPropagation($event)"
          focusSelect
        />
      </div>
      <div
        id="{{ 'bill-date' + item._id }}"
        class="bill-date"
        [class.is-disabled]="isReadOnly"
        [class.field]="isExpanded"
      >
        <div class="value">
          <!-- TODO: Pipe for date that has null handling -->
          <!-- {{dateOfBillEdit}} -->
          {{ dateOfBillEdit ? (dateOfBillEdit | date : dateFormat) : '' }}
        </div>

        <ops-calendar
          label=""
          (dateChanged)="onSelectdateOfBill($event)"
          formName="dateOfBillEdit"
          [date]="dateOfBillEdit"
        ></ops-calendar>
      </div>
      <div
        id="{{ 'paymentDate-' + item._id }}"
        class="date"
        [class.is-disabled]="isReadOnly"
        [class.field]="isExpanded"
      >
        <div class="value with-reminder-icon">
          <!-- TODO: Pipe for date that has null handling -->
          {{ paymentDateEdit ? (paymentDateEdit | date : dateFormat) : '' }}

          <div class="reminder-icon icon">
            <svg
              *ngIf="item.hasReminder"
              [class]="reminderClassName"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M18.1916 13.0403C18.1916 9.63879 15.4341 6.88128 12.0325 6.88128C8.63098 6.88128 5.87347 9.63879 5.87347 13.0403C5.87347 16.4419 8.63098 19.1994 12.0325 19.1994C15.4341 19.1994 18.1916 16.4419 18.1916 13.0403ZM19.6129 13.0403C19.6129 8.85382 16.2191 5.45996 12.0325 5.45996C7.846 5.45996 4.45215 8.85382 4.45215 13.0403C4.45215 17.2269 7.846 20.6207 12.0325 20.6207C16.2191 20.6207 19.6129 17.2269 19.6129 13.0403Z"
                fill="inherit"
              />
              <path
                d="M6.6873 4.09214C5.21151 4.97371 3.97645 6.2069 3.09265 7.68136C2.8914 8.01709 3.03181 8.44548 3.38043 8.62344C3.72906 8.80141 4.15359 8.6613 4.35841 8.32775C5.1015 7.1176 6.1205 6.10014 7.33177 5.35889C7.66564 5.15457 7.80639 4.73025 7.62895 4.38136C7.45151 4.03246 7.02333 3.89141 6.6873 4.09214Z"
                fill="inherit"
              />
              <path
                d="M17.3782 4.09215C18.8539 4.97371 20.089 6.20688 20.9728 7.68131C21.174 8.01706 21.0336 8.44547 20.685 8.62345C20.3363 8.80142 19.9118 8.66131 19.7069 8.32773C18.9639 7.11763 17.9449 6.10021 16.7337 5.35897C16.3998 5.15464 16.259 4.7303 16.4365 4.38138C16.6139 4.03246 17.0421 3.8914 17.3782 4.09215Z"
                fill="inherit"
              />
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M12.7431 9.25021V12.6479C12.7431 12.7107 12.7681 12.771 12.8125 12.8154L14.43 14.433C14.7076 14.7105 14.7076 15.1605 14.43 15.438C14.1525 15.7155 13.7026 15.7155 13.425 15.438L11.8075 13.8204C11.4965 13.5095 11.3218 13.0877 11.3218 12.6479V9.25021C11.3218 8.85772 11.64 8.53955 12.0324 8.53955C12.4249 8.53955 12.7431 8.85772 12.7431 9.25021Z"
                fill="inherit"
              />
            </svg>
          </div>
        </div>
        <ops-calendar
          label=""
          (dateChanged)="onSelectPaymentDate($event)"
          formName="paymentDateEdit"
          [date]="paymentDateEdit"
        ></ops-calendar>
      </div>
      <div class="unit" [class.is-disabled]="isReadOnly" >
        <div *ngIf="!isExpanded"></div>
        <input
          tabindex="0"
          class="field"
          *ngIf="isExpanded"
          [disabled]="isReadOnly"
          value="{{ units }}"
          [(ngModel)]="unitEdit"
          (click)="stopPropagation($event)"
          opsNumber
        />
      </div>
      <div class="days" [class.is-disabled]="isReadOnly">
        <div *ngIf="!isExpanded"></div>
        <input
          opsNumber
          tabindex="0"
          class="field"
          *ngIf="isExpanded"
          [disabled]="isReadOnly"
          value="{{ days }}"
          [(ngModel)]="daysEdit"
          (click)="stopPropagation($event)"
        />
      </div>
      <div class="cost" [class.is-disabled]="isReadOnly">
        <div *ngIf="!isExpanded"></div>
        <input
          opsNumber
          tabindex="0"
          class="field"
          *ngIf="isExpanded"
          [disabled]="isReadOnly"
          value="{{ cost }}"
          [(ngModel)]="unitCostEdit"
          (click)="stopPropagation($event)"
        />
      </div>
      <div class="icon" (click)="$event.stopPropagation()">
        <img
          src="assets/checkmark-double-circled-green.svg"
          *ngIf="costStatusEdit?.toUpperCase() === 'PAID'"
        />
      </div>
      <div
        class="actual"
        [class.display-column]="hasDifferentCurrency && isExpanded"
        [class.is-disabled]="isReadOnly"
      >
        <span>
          {{ currencySymbol }} {{ item.total ?? 0 | number : '.0-0' }}
        </span>
        <span *ngIf="hasDifferentCurrency && isExpanded">
          {{ currencyExchangeSymbol }} {{ totalExchange | number : '.0-0' }}
        </span>
      </div>
      <div
        class="estimated"
        [class.display-column]="hasDifferentCurrency && isExpanded"
        [class.is-disabled]="isReadOnly"
      >
        <span>
          {{ itemCurrencySymbol }}
          {{ item.estimatedTotal ?? 0 | number : '.0-0' }}
        </span>
        <span *ngIf="hasDifferentCurrency && isExpanded">
          {{ currencyExchangeSymbol }}
          {{ estimatedTotalExchange | number : '.0-0' }}
        </span>
      </div>
      <div
        class="icon comment-icon"
        id="{{ 'comments-' + item._id }}"
        (click)="openComments('comments-popup-' + item._id, $event)"
        *ngIf="item.hasComment"
      >
        <img src="assets/comment_true.svg" />
      </div>
      <div class="document-icon icon" [class.no-documents]="!item?.documents?.length">
        <button
          (click)="onHandleDocumentClick($event)"
          class="button-add-document"
          [class.document]="item?.documents?.length > 0"
          [class.add-new]="!item?.documents?.length"
        >
          <svg
            class="add-document"
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="inherit"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M10.0013 6.66699V13.3337M13.3346 10.0003H6.66797M10.0013 18.3337C14.6037 18.3337 18.3346 14.6027 18.3346 10.0003C18.3346 5.39795 14.6037 1.66699 10.0013 1.66699C5.39893 1.66699 1.66797 5.39795 1.66797 10.0003C1.66797 14.6027 5.39893 18.3337 10.0013 18.3337Z"
              stroke="inherit"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
          <svg
            class="edit-document"
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="inherit"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M2.5 15.0003H2H2.5ZM2.5 5.00032H3H2.5ZM5.83333 1.66699V1.16699V1.66699ZM14.1667 1.66699V1.16699V1.66699ZM17.5 5.00033H17H17.5ZM17.5 10.2863H18H17.5ZM9.45262 18.3337V17.8337V18.3337ZM5.83333 18.3337V18.8337V18.3337ZM16.5237 12.6433L16.1701 12.2898H16.1701L16.5237 12.6433ZM11.8096 17.3573L12.1632 17.7109V17.7109L11.8096 17.3573ZM10.8333 15.0003H10.3333H10.8333ZM14.1667 11.667V11.167V11.667ZM6.66667 5.33366C6.39052 5.33366 6.16667 5.55752 6.16667 5.83366C6.16667 6.1098 6.39052 6.33366 6.66667 6.33366V5.33366ZM13.3333 6.33366C13.6095 6.33366 13.8333 6.1098 13.8333 5.83366C13.8333 5.55752 13.6095 5.33366 13.3333 5.33366V6.33366ZM6.66667 9.50033C6.39052 9.50033 6.16667 9.72418 6.16667 10.0003C6.16667 10.2765 6.39052 10.5003 6.66667 10.5003V9.50033ZM10 10.5003C10.2761 10.5003 10.5 10.2765 10.5 10.0003C10.5 9.72418 10.2761 9.50033 10 9.50033V10.5003ZM3 15.0003L3 5.00032H2L2 15.0003H3ZM5.83333 2.16699L14.1667 2.16699V1.16699L5.83333 1.16699V2.16699ZM17 5.00033V10.2863H18V5.00033H17ZM9.45262 17.8337H5.83333V18.8337H9.45262V17.8337ZM16.1701 12.2898L11.4561 17.0038L12.1632 17.7109L16.8772 12.9969L16.1701 12.2898ZM9.45262 18.8337C10.4693 18.8337 11.4443 18.4298 12.1632 17.7109L11.4561 17.0038C10.9247 17.5351 10.2041 17.8337 9.45262 17.8337V18.8337ZM17 10.2863C17 11.0377 16.7015 11.7584 16.1701 12.2898L16.8772 12.9969C17.5961 12.278 18 11.3029 18 10.2863H17ZM3 5.00032C3 3.43552 4.26853 2.16699 5.83333 2.16699V1.16699C3.71624 1.16699 2 2.88323 2 5.00032H3ZM2 15.0003C2 17.1174 3.71624 18.8337 5.83333 18.8337V17.8337C4.26853 17.8337 3 16.5651 3 15.0003H2ZM14.1667 2.16699C15.7315 2.16699 17 3.43552 17 5.00033H18C18 2.88323 16.2838 1.16699 14.1667 1.16699V2.16699ZM11.3333 18.3337V15.0003H10.3333V18.3337H11.3333ZM14.1667 12.167L17.5 12.167L17.5 11.167L14.1667 11.167V12.167ZM11.3333 15.0003C11.3333 13.4355 12.6019 12.167 14.1667 12.167V11.167C12.0496 11.167 10.3333 12.8832 10.3333 15.0003H11.3333ZM6.66667 6.33366H13.3333V5.33366H6.66667V6.33366ZM6.66667 10.5003H10V9.50033H6.66667V10.5003Z"
              fill="inherit"
            />
          </svg>
        </button>
      </div>
      <!-- <div class="document-icon icon">
        <img
          *ngIf="item.documents?.length"
          [src]="item.documents?.length ? 'assets/document-icon-blue.svg' : ''"
        />
      </div> -->
      <div
        class="kebab-menu"
        tabindex="0"
        role="button"
        [class.should-enable-only-comments-feature]="shouldEnableOnlyCommentsFeature"
        [opsActionMenu]="'item-action-' + item._id"
        [optionsFactory]="getItemActionMenuOptions.bind(this)"
        (itemSelected)="onItemActionSelected($event)"
      >
        <img src="assets/kebab-menu-purple-nofill.svg" />
      </div>

    </div>
    <div class="hidden-row" *ngIf="isExpanded">
      <div class="label-row">
        <div class="label type">
          {{ 'productionCost.costAccordionItem.costType' | translate }}
        </div>
        <div class="label payment-method">
          {{ 'productionCost.costAccordionItem.paymentMethod' | translate }}
        </div>
        <div class="label paid-by">
          {{ 'productionCost.costAccordionItem.paymentBy' | translate }}
        </div>
        <div class="label status">
          {{ 'productionCost.costAccordionItem.costStatus' | translate }}
        </div>
        <div class="label assign-to">
          {{ 'productionCost.costAccordionItem.assignTo' | translate }}
        </div>
        <div class="label currency">
          {{ 'productionCost.costAccordionItem.currency' | translate }}
        </div>
        <div
          class="label tax"
          tabindex="0"
          role="button"
          enterPress="onToggleTax()"
          (keydown.enter)="onToggleTax()"
          (click)="onToggleTax()"
        >
          <div class="checkbox" [class.is-disabled]="isReadOnly">
            <img
              src="assets/check-box.svg"
              *ngIf="isTaxed || taxPercentageEdit"
            />
          </div>
          {{ 'productionCost.costAccordionItem.tax' | translate }}
        </div>
        <div class="label tax-amount">
          {{ 'productionCost.costAccordionItem.taxAmount' | translate }}
        </div>
      </div>
      <div class="first-row">
        <div
          id="{{ 'cost-type' + item._id }}"
          class="type clickable"
          [class.field]="isExpanded"
          tabindex="0"
          role="button"
          [class.is-disabled]="isReadOnly"
          enterPress="openModal('dropdown-cost-type' + item._id, $event)"
          (keydown.enter)="openModal('dropdown-cost-type' + item._id, $event)"
          (click)="openModal('dropdown-cost-type' + item._id, $event)"
        >
          <div class="value">
            {{ costTypeEdit | translate }}
          </div>
          <div class="arrow" *ngIf="isExpanded">
            <img src="assets/arrow-down-purple.svg" />
          </div>
          <ops-dropdown
            id="{{ 'dropdown-cost-type' + item._id }}"
            parentId="{{ 'cost-type' + item._id }}"
            [options]="costTypeOptions"
            [isMultiSelect]="false"
            [startingFocusIndex]="0"
            (valueSelected)="onSelectCostType($event)"
            class="dropdown-component"
          >
          </ops-dropdown>
        </div>
        <div
          id="{{ 'method' + item._id }}"
          class="payment-method clickable"
          [class.field]="isExpanded"
          tabindex="0"
          role="button"
          [class.is-disabled]="isReadOnly"
          enterPress="openModal('dropdown-method' + item._id, $event)"
          (keydown.enter)="openModal('dropdown-method' + item._id, $event)"
          (click)="openModal('dropdown-method' + item._id, $event)"
        >
          <!-- <div *ngIf="!paymentMethodEdit || paymentMethodEdit.length < 1" class="label">
                        -
                    </div> -->
          <div class="value">
            {{ paymentMethodEdit | translate }}
          </div>
          <div class="arrow" *ngIf="isExpanded">
            <img src="assets/arrow-down-purple.svg" />
          </div>
          <ops-dropdown
            id="{{ 'dropdown-method' + item._id }}"
            parentId="{{ 'method' + item._id }}"
            [options]="paymentMethodOptions"
            [isMultiSelect]="false" 
            [startingFocusIndex]="0"
            (valueSelected)="onSelectPaymentMethod($event)"
            class="dropdown-component"
          >
          </ops-dropdown>
        </div>
        <div
          id="{{ 'paid-by' + item._id }}"
          class="paid-by clickable"
          [class.field]="isExpanded"
          [class.disabled]="!paymentMethodEdit"
          tabindex="0"
          role="button"
          [class.is-disabled]="isReadOnly"
          enterPress="()=>{paymentMethodEdit &&
          openModal('dropdown-paid-by' + item._id, $event)})"
          (keydown.enter)="
            paymentMethodEdit &&
              openModal('dropdown-paid-by' + item._id, $event)
          "
          (click)="
            paymentMethodEdit &&
              openModal('dropdown-paid-by' + item._id, $event)
          "
        >
          <!-- <div *ngIf="!paidByEdit || paidByEdit.length < 1" class="label">
                        -
                    </div> -->
          <div class="value">
            {{ paidByEdit | translate }}
          </div>
          <div class="arrow" *ngIf="isExpanded">
            <img src="assets/arrow-down-purple.svg" />
          </div>
          <ops-dropdown
            id="{{ 'dropdown-paid-by' + item._id }}"
            parentId="{{ 'paid-by' + item._id }}"
            [options]="paidByOptions"
            [addNewOption]="showAddNewOption"
            [isMultiSelect]="false"
            [ignoreSort]="'true'"
            [startingFocusIndex]="0"
            (addNewOption)="onAddNewPaidByOption($event)"
            (valueSelected)="onSelectpaidBy($event)"
            class="dropdown-component"
          >
          </ops-dropdown>
        </div>
        <div
          id="{{ 'cost-status' + item._id }}"
          class="status field clickable"
          tabindex="0"
          role="button"
          [class.is-disabled]="isFullPrevention"
          enterPress="openModal('dropdown-cost-status' + item._id, $event)"
          (keydown.enter)="openModal('dropdown-cost-status' + item._id, $event)"
          (click)="openModal('dropdown-cost-status' + item._id, $event)"
        >
          <div class="value">
            {{ costStatusEdit | translate }}
          </div>
          <div class="arrow">
            <img src="assets/arrow-down-purple.svg" />
          </div>
          <ops-dropdown
            id="{{ 'dropdown-cost-status' + item._id }}"
            parentId="{{ 'cost-status' + item._id }}"
            [options]="costStatusOptions"
            [isMultiSelect]="false"
            [startingFocusIndex]="0"
            (valueSelected)="onSelectCostStatus($event)"
            class="dropdown-component"
          >
          </ops-dropdown>
        </div>
        <div
          id="{{ 'assign-to' + item._id }}"
          class="assign-to field clickable"
          tabindex="0"
          role="button"
          [class.is-disabled]="isReadOnly"
          enterPress="openModal('dropdown-assign-to' + item._id, $event)"
          (keydown.enter)="openModal('dropdown-assign-to' + item._id, $event)"
          (click)="openModal('dropdown-assign-to' + item._id, $event)"
        >
          <div class="value">
            {{ assignToEdit | translate }}
          </div>
          <div class="arrow">
            <img src="assets/arrow-down-purple.svg" />
          </div>
          <ops-dropdown
            id="{{ 'dropdown-assign-to' + item._id }}"
            parentId="{{ 'assign-to' + item._id }}"
            [options]="assignToOptions"
            [isMultiSelect]="false"
            [startingFocusIndex]="0"
            (valueSelected)="onSelectAssignTo($event)"
            class="dropdown-component"
          >
          </ops-dropdown>
        </div>
        <div
          id="{{ 'currency' + item._id }}"
          class="currency field clickable"
          tabindex="0"
          role="button"
          [class.is-disabled]="isReadOnly"
          enterPress="openModal('dropdown-currency' + item._id, $event)"
          (keydown.enter)="openModal('dropdown-currency' + item._id, $event)"
          (click)="openModal('dropdown-currency' + item._id, $event)"
        >
          <div class="value">
            {{ currencyEdit | translate }}
          </div>
          <div class="arrow">
            <img src="assets/arrow-down-purple.svg" />
          </div>
          <ops-dropdown
            id="{{ 'dropdown-currency' + item._id }}"
            parentId="{{ 'currency' + item._id }}"
            [options]="currencyOptions"
            [ignoreSort]="'true'"
            [isMultiSelect]="false"
            [startingFocusIndex]="0"
            (valueSelected)="onSelectCurrency($event)"
            class="dropdown-component"
          >
          </ops-dropdown>
        </div>
        <div class="field tax" [class.is-disabled]="isReadOnly">
          <input
            tabindex="0"
            value="{{ taxPercentageEdit | number : '.0-0' }}"
            (input)="onEditTax($event)"
            (click)="stopPropagation($event)"
            [disabled]="!(isTaxed || taxPercentageEdit)"
          />
          %&nbsp;
        </div>
        <div class="tax-amount" [class.is-disabled]="isReadOnly">
          {{ currencySymbol }}
          {{
            ((item.units ?? 0) *
              (item.days ?? 0) *
              (item.cost ?? 0) *
              taxPercentageEdit) /
              100 ??
              0 | number : '.0-0'
          }}
        </div>
      </div>
      <div class="button-row">
        <div
          class="reminder field clickable"
          [class.is-disabled]="isReadOnly"
          (click)="onToggleReminder($event)"
        >
          <div class="checkbox">
            <img
              src="assets/checkmark-square-white-in-purple2.svg"
              *ngIf="hasReminderEdit"
            />
          </div>
          <div class="label">
            {{ 'productionCost.costAccordionItem.paymentReminder' | translate }}
          </div>
        </div>
        <div class="exchange-rate" [class.is-disabled]="isReadOnly">
          <div class="label">
            {{ 'productionCost.costAccordionItem.exRate' | translate }}
          </div>
          <div class="input-with-button">
            <ops-numeric-input
              class="exchange-rate-input"
              [disabled]="isReadOnly"
              [value]="exchangeRateEdit"
              [decimal]="4"
              (onValueChange)="onExchangeRateInput($event)"
            ></ops-numeric-input>
            <button
              class="reciprocal-btn"
              type="button"
              (click)="calculateReciprocal()"
              [disabled]="isReadOnly || !exchangeRateEdit || exchangeRateEdit === 0"
            >
              1/x
            </button>
          </div>
        </div>
        <div
          class="cancel btn"
          tabindex="0"
          role="button"
          enterPress="()=>{onCancelChanges(); $event.stopPropagation()}"
          (keydown.enter)="onCancelChanges(); $event.stopPropagation()"
          (click)="onCancelChanges(); $event.stopPropagation()"
        >
          {{ 'productionCost.costAccordionItem.cancel' | translate }}
        </div>
        <div
          class="save btn"
          tabindex="0"
          role="button"
          enterPress="()=>{onSaveChanges(); $event.stopPropagation()}"
          (keydown.enter)="onSaveChanges(); $event.stopPropagation()"
          (click)="onSaveChanges(); $event.stopPropagation()"
        >
          {{ 'productionCost.costAccordionItem.save' | translate }}
        </div>
      </div>
    </div>
  </div>
</div>

<ops-document-modal
  id="{{ 'document-modal' + item._id }}"
  type="project"
  [item]="item"
  [title]="itemGroupTitle"
  (filesUploaded)="onFilesUploaded($event)"
></ops-document-modal>

<!-- Action Menu -->
<ops-action-menu
  [shouldEnableOnlyCommentsFeature]="shouldEnableOnlyCommentsFeature"
  [menuId]="'item-action-' + item._id"
  (itemSelected)="onItemActionSelected($event)"
></ops-action-menu>


<!-- Comment Popup -->
<ops-comment-popup
  id="{{ 'comments-popup-' + item._id }}"
  parentId="{{ 'comments-' + item._id }}"
  [comments]="item.comments"
  (saveComment)="onSaveComment($event)"
  (deleteComment)="onDeleteComment($event)"
  class="comment-window"
></ops-comment-popup>

<!-- Custom Currency Modal -->
<ops-custom-currency-modal
  [isVisible]="showCustomCurrencyForm"
  [config]="customCurrencyConfig"
  (currencyAdded)="onCustomCurrencyAdded($event)"
  (modalClosed)="onCustomCurrencyModalClosed()"
></ops-custom-currency-modal>
